import { z } from "zod";

export const importCommercialSchema = z.object({
  firstName: z
    .string()
    .min(1, "Le prénom est requis")
    .max(64, "Veuillez entrer un prénom valide"),
  lastName: z
    .string()
    .min(1, "Le nom est requis")
    .max(64, "Veuillez entrer un nom valide"),
  email: z.string().email("Email invalide").min(1, "L'email est requis"),
});

export const defaultImportCommercialValues = {
  firstName: "",
  lastName: "",
  email: "",
};

export type ImportCommercialForm = z.infer<typeof importCommercialSchema>;
